// Moodist MIT; pinned 285ecdbfc67fb082833eee8cef9cd34bbdb1d755. Generated by scripts/sync-moodist.mjs.
export const MOODIST_SOUNDS = [
  {
    "id": "river",
    "name": "River",
    "category": "nature",
    "path": "/sounds/nature/river.mp3"
  },
  {
    "id": "waves",
    "name": "Waves",
    "category": "nature",
    "path": "/sounds/nature/waves.mp3"
  },
  {
    "id": "campfire",
    "name": "Campfire",
    "category": "nature",
    "path": "/sounds/nature/campfire.mp3"
  },
  {
    "id": "wind",
    "name": "Wind",
    "category": "nature",
    "path": "/sounds/nature/wind.mp3"
  },
  {
    "id": "howling-wind",
    "name": "Howling Wind",
    "category": "nature",
    "path": "/sounds/nature/howling-wind.mp3"
  },
  {
    "id": "wind-in-trees",
    "name": "Wind in Trees",
    "category": "nature",
    "path": "/sounds/nature/wind-in-trees.mp3"
  },
  {
    "id": "waterfall",
    "name": "Waterfall",
    "category": "nature",
    "path": "/sounds/nature/waterfall.mp3"
  },
  {
    "id": "walk-in-snow",
    "name": "Walk in Snow",
    "category": "nature",
    "path": "/sounds/nature/walk-in-snow.mp3"
  },
  {
    "id": "walk-on-leaves",
    "name": "Walk on Leaves",
    "category": "nature",
    "path": "/sounds/nature/walk-on-leaves.mp3"
  },
  {
    "id": "walk-on-gravel",
    "name": "Walk on Gravel",
    "category": "nature",
    "path": "/sounds/nature/walk-on-gravel.mp3"
  },
  {
    "id": "droplets",
    "name": "Droplets",
    "category": "nature",
    "path": "/sounds/nature/droplets.mp3"
  },
  {
    "id": "jungle",
    "name": "Jungle",
    "category": "nature",
    "path": "/sounds/nature/jungle.mp3"
  },
  {
    "id": "light-rain",
    "name": "Light Rain",
    "category": "rain",
    "path": "/sounds/rain/light-rain.mp3"
  },
  {
    "id": "heavy-rain",
    "name": "Heavy Rain",
    "category": "rain",
    "path": "/sounds/rain/heavy-rain.mp3"
  },
  {
    "id": "thunder",
    "name": "Thunder",
    "category": "rain",
    "path": "/sounds/rain/thunder.mp3"
  },
  {
    "id": "rain-on-window",
    "name": "Rain on Window",
    "category": "rain",
    "path": "/sounds/rain/rain-on-window.mp3"
  },
  {
    "id": "rain-on-car-roof",
    "name": "Rain on Car Roof",
    "category": "rain",
    "path": "/sounds/rain/rain-on-car-roof.mp3"
  },
  {
    "id": "rain-on-umbrella",
    "name": "Rain on Umbrella",
    "category": "rain",
    "path": "/sounds/rain/rain-on-umbrella.mp3"
  },
  {
    "id": "rain-on-tent",
    "name": "Rain on Tent",
    "category": "rain",
    "path": "/sounds/rain/rain-on-tent.mp3"
  },
  {
    "id": "rain-on-leaves",
    "name": "Rain on Leaves",
    "category": "rain",
    "path": "/sounds/rain/rain-on-leaves.mp3"
  },
  {
    "id": "birds",
    "name": "Birds",
    "category": "animals",
    "path": "/sounds/animals/birds.mp3"
  },
  {
    "id": "seagulls",
    "name": "Seagulls",
    "category": "animals",
    "path": "/sounds/animals/seagulls.mp3"
  },
  {
    "id": "crickets",
    "name": "Crickets",
    "category": "animals",
    "path": "/sounds/animals/crickets.mp3"
  },
  {
    "id": "wolf",
    "name": "Wolf",
    "category": "animals",
    "path": "/sounds/animals/wolf.mp3"
  },
  {
    "id": "owl",
    "name": "Owl",
    "category": "animals",
    "path": "/sounds/animals/owl.mp3"
  },
  {
    "id": "frog",
    "name": "Frog",
    "category": "animals",
    "path": "/sounds/animals/frog.mp3"
  },
  {
    "id": "dog-barking",
    "name": "Dog Barking",
    "category": "animals",
    "path": "/sounds/animals/dog-barking.mp3"
  },
  {
    "id": "horse-gallop",
    "name": "Horse Gallop",
    "category": "animals",
    "path": "/sounds/animals/horse-gallop.mp3"
  },
  {
    "id": "cat-purring",
    "name": "Cat Purring",
    "category": "animals",
    "path": "/sounds/animals/cat-purring.mp3"
  },
  {
    "id": "crows",
    "name": "Crows",
    "category": "animals",
    "path": "/sounds/animals/crows.mp3"
  },
  {
    "id": "whale",
    "name": "Whale",
    "category": "animals",
    "path": "/sounds/animals/whale.mp3"
  },
  {
    "id": "beehive",
    "name": "Beehive",
    "category": "animals",
    "path": "/sounds/animals/beehive.mp3"
  },
  {
    "id": "woodpecker",
    "name": "Woodpecker",
    "category": "animals",
    "path": "/sounds/animals/woodpecker.mp3"
  },
  {
    "id": "chickens",
    "name": "Chickens",
    "category": "animals",
    "path": "/sounds/animals/chickens.mp3"
  },
  {
    "id": "cows",
    "name": "Cows",
    "category": "animals",
    "path": "/sounds/animals/cows.mp3"
  },
  {
    "id": "sheep",
    "name": "Sheep",
    "category": "animals",
    "path": "/sounds/animals/sheep.mp3"
  },
  {
    "id": "highway",
    "name": "Highway",
    "category": "urban",
    "path": "/sounds/urban/highway.mp3"
  },
  {
    "id": "road",
    "name": "Road",
    "category": "urban",
    "path": "/sounds/urban/road.mp3"
  },
  {
    "id": "ambulance-siren",
    "name": "Ambulance Siren",
    "category": "urban",
    "path": "/sounds/urban/ambulance-siren.mp3"
  },
  {
    "id": "busy-street",
    "name": "Busy Street",
    "category": "urban",
    "path": "/sounds/urban/busy-street.mp3"
  },
  {
    "id": "crowd",
    "name": "Crowd",
    "category": "urban",
    "path": "/sounds/urban/crowd.mp3"
  },
  {
    "id": "traffic",
    "name": "Traffic",
    "category": "urban",
    "path": "/sounds/urban/traffic.mp3"
  },
  {
    "id": "fireworks",
    "name": "Fireworks",
    "category": "urban",
    "path": "/sounds/urban/fireworks.mp3"
  },
  {
    "id": "cafe",
    "name": "Cafe",
    "category": "places",
    "path": "/sounds/places/cafe.mp3"
  },
  {
    "id": "airport",
    "name": "Airport",
    "category": "places",
    "path": "/sounds/places/airport.mp3"
  },
  {
    "id": "church",
    "name": "Church",
    "category": "places",
    "path": "/sounds/places/church.mp3"
  },
  {
    "id": "temple",
    "name": "Temple",
    "category": "places",
    "path": "/sounds/places/temple.mp3"
  },
  {
    "id": "construction-site",
    "name": "Construction Site",
    "category": "places",
    "path": "/sounds/places/construction-site.mp3"
  },
  {
    "id": "underwater",
    "name": "Underwater",
    "category": "places",
    "path": "/sounds/places/underwater.mp3"
  },
  {
    "id": "crowded-bar",
    "name": "Crowded Bar",
    "category": "places",
    "path": "/sounds/places/crowded-bar.mp3"
  },
  {
    "id": "night-village",
    "name": "Night Village",
    "category": "places",
    "path": "/sounds/places/night-village.mp3"
  },
  {
    "id": "subway-station",
    "name": "Subway Station",
    "category": "places",
    "path": "/sounds/places/subway-station.mp3"
  },
  {
    "id": "office",
    "name": "Office",
    "category": "places",
    "path": "/sounds/places/office.mp3"
  },
  {
    "id": "supermarket",
    "name": "Supermarket",
    "category": "places",
    "path": "/sounds/places/supermarket.mp3"
  },
  {
    "id": "carousel",
    "name": "Carousel",
    "category": "places",
    "path": "/sounds/places/carousel.mp3"
  },
  {
    "id": "laboratory",
    "name": "Laboratory",
    "category": "places",
    "path": "/sounds/places/laboratory.mp3"
  },
  {
    "id": "laundry-room",
    "name": "Laundry Room",
    "category": "places",
    "path": "/sounds/places/laundry-room.mp3"
  },
  {
    "id": "restaurant",
    "name": "Restaurant",
    "category": "places",
    "path": "/sounds/places/restaurant.mp3"
  },
  {
    "id": "library",
    "name": "Library",
    "category": "places",
    "path": "/sounds/places/library.mp3"
  },
  {
    "id": "train",
    "name": "Train",
    "category": "transport",
    "path": "/sounds/transport/train.mp3"
  },
  {
    "id": "inside-a-train",
    "name": "Inside a Train",
    "category": "transport",
    "path": "/sounds/transport/inside-a-train.mp3"
  },
  {
    "id": "airplane",
    "name": "Airplane",
    "category": "transport",
    "path": "/sounds/transport/airplane.mp3"
  },
  {
    "id": "submarine",
    "name": "Submarine",
    "category": "transport",
    "path": "/sounds/transport/submarine.mp3"
  },
  {
    "id": "sailboat",
    "name": "Sailboat",
    "category": "transport",
    "path": "/sounds/transport/sailboat.mp3"
  },
  {
    "id": "rowing-boat",
    "name": "Rowing Boat",
    "category": "transport",
    "path": "/sounds/transport/rowing-boat.mp3"
  },
  {
    "id": "keyboard",
    "name": "Keyboard",
    "category": "things",
    "path": "/sounds/things/keyboard.mp3"
  },
  {
    "id": "typewriter",
    "name": "Typewriter",
    "category": "things",
    "path": "/sounds/things/typewriter.mp3"
  },
  {
    "id": "paper",
    "name": "Paper",
    "category": "things",
    "path": "/sounds/things/paper.mp3"
  },
  {
    "id": "clock",
    "name": "Clock",
    "category": "things",
    "path": "/sounds/things/clock.mp3"
  },
  {
    "id": "wind-chimes",
    "name": "Wind Chimes",
    "category": "things",
    "path": "/sounds/things/wind-chimes.mp3"
  },
  {
    "id": "singing-bowl",
    "name": "Singing Bowl",
    "category": "things",
    "path": "/sounds/things/singing-bowl.mp3"
  },
  {
    "id": "ceiling-fan",
    "name": "Ceiling Fan",
    "category": "things",
    "path": "/sounds/things/ceiling-fan.mp3"
  },
  {
    "id": "dryer",
    "name": "Dryer",
    "category": "things",
    "path": "/sounds/things/dryer.mp3"
  },
  {
    "id": "slide-projector",
    "name": "Slide Projector",
    "category": "things",
    "path": "/sounds/things/slide-projector.mp3"
  },
  {
    "id": "boiling-water",
    "name": "Boiling Water",
    "category": "things",
    "path": "/sounds/things/boiling-water.mp3"
  },
  {
    "id": "bubbles",
    "name": "Bubbles",
    "category": "things",
    "path": "/sounds/things/bubbles.mp3"
  },
  {
    "id": "tuning-radio",
    "name": "Tuning Radio",
    "category": "things",
    "path": "/sounds/things/tuning-radio.mp3"
  },
  {
    "id": "morse-code",
    "name": "Morse Code",
    "category": "things",
    "path": "/sounds/things/morse-code.mp3"
  },
  {
    "id": "washing-machine",
    "name": "Washing Machine",
    "category": "things",
    "path": "/sounds/things/washing-machine.mp3"
  },
  {
    "id": "vinyl-effect",
    "name": "Vinyl Effect",
    "category": "things",
    "path": "/sounds/things/vinyl-effect.mp3"
  },
  {
    "id": "windshield-wipers",
    "name": "Windshield Wipers",
    "category": "things",
    "path": "/sounds/things/windshield-wipers.mp3"
  },
  {
    "id": "white-noise",
    "name": "White Noise",
    "category": "noise",
    "path": "/sounds/noise/white-noise.wav"
  },
  {
    "id": "pink-noise",
    "name": "Pink Noise",
    "category": "noise",
    "path": "/sounds/noise/pink-noise.wav"
  },
  {
    "id": "brown-noise",
    "name": "Brown Noise",
    "category": "noise",
    "path": "/sounds/noise/brown-noise.wav"
  }
] as const
